import { Component, OnInit, ViewChild } from "@angular/core";

import { CalendarOptions, EventSourceInput } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import esLocale from "@fullcalendar/core/locales/es";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";

import { GeneralEmptyModalComponent } from "src/app/shared/modals/general-empty-modal/general-empty-modal.component";

import { CalendarService } from "src/app/calendar/services/tipoSesion/calendar.service";
import { AuthenticationService } from "src/app/auth/services/authentication.service";

import {
  ICalendarSessionItem,
  ISessionDetailsResponse,
} from "src/app/calendar/interfaces/tipo-sesion";
import { ModalConfig } from "src/app/shared/modals/modal.interfaces";
import { getColorByProcessStatus } from "src/app/calendar/constants/ProcessId";
import { ModalSharedServiceService } from "src/app/shared/modals/modal-service.service";

@Component({
  selector: "app-full-calendar-component",
  templateUrl: "./full-calendar-component.component.html",
  styleUrls: ["./full-calendar-component.component.css"],
})
export class FullCalendarComponentComponent implements OnInit {
  public isLoading = true;
  @ViewChild("modal") private modalComponent!: GeneralEmptyModalComponent;
  @ViewChild("modalEdit")
  private modalComponentEdit!: GeneralEmptyModalComponent;
  public modalConfig: ModalConfig = {
    modalTitle: "Editar",
    hideDismissButton: true,
    hideCloseButton: true,
    ngModalOptions: {
      centered: true,
      size: "lg",
      backdrop: "static",
    },
  };
  public currentEvents: EventSourceInput = [];
  public sessions: ICalendarSessionItem[] = [];
  public selectedEvent: ISessionDetailsResponse | null = null;
  public selectedClickDate: Date | null = null;
  public openedModal: boolean = false;

  calendarOptions: CalendarOptions = {
    initialView: "timeGridWeek",
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    timeZone: "local",
    locale: esLocale,
    headerToolbar: {
      left: "prev,next,today,month",
      center: "title",
      right: "dayGridMonth,timeGridWeek,timeGridDay,", // user can switch between the two
    },
    businessHours: {
      // Definir las horas laborales
      daysOfWeek: [1, 2, 3, 4, 5, 6, 7, 8], // De lunes a viernes
      startTime: "00:00", // Hora de inicio
      endTime: "24:00", // Hora de finalización
    },
    slotLabelFormat: {
      hour: "2-digit",
      minute: "2-digit",
      omitZeroMinute: false,
      meridiem: "short",
    },
    initialDate: new Date().setHours(8, 0, 0, 0),
    // initialDate: new Date(2024, 2, 11, 8, 0, 0, 0),
    scrollTime: "12:00", // Hora inicial de desplazamiento
    eventClick: this.handleEventClick.bind(this),
    dateClick: this.handleDateClick.bind(this),
  };

  constructor(
    private calendarService: CalendarService,
    private authLocalService: AuthenticationService,
    private sharedModalService: ModalSharedServiceService
  ) {}

  ngOnInit(): void {
    const u = this.authLocalService.currentUserValue;
    this.calendarService.getSessionsById(u.id.toString() ?? "");
    this.calendarService.getSessionsByPersonObservable().subscribe(d => {
      if (d.length > 0) {
        this.sessions = d;
        this.currentEvents = this.transformDataForCalendar(d);
      } else {
        this.currentEvents = [];
      }
      this.isLoading = false;
    });
  }

  private transformDataForCalendar(
    data: ICalendarSessionItem[]
  ): EventSourceInput {
    const newData = data.map((session, i) => ({
      id: i,
      groupId: session.fkIdSesionCalendario,
      title: session.nombreSesion,
      start: session.fechaInicio,
      end: session.fechaFin,
      color: getColorByProcessStatus(
        session.fkIdProcesoSesion,
        session.fkIdProcesoRpa,
        session.asistenciaGbuIntegrada,
        session.asistenciaIntegradaSifca
      ),
    })) as EventSourceInput;
    return newData;
  }

  handleEventClick(clickInfo: any) {
    if (this.openedModal) {
      return;
    }
    this.openedModal = true;
    this.modalConfig.modalTitle = `Detalles de la Sesion: ${clickInfo.event.title}`;
    this.calendarService.getSessionDetails(clickInfo.event.groupId).subscribe({
      next: d => {
        this.selectedEvent = d;
        this.selectedClickDate = new Date(clickInfo.event.start);
        this.modalComponentEdit.open().then(() => (this.openedModal = false));
      },
      error: e => {
        this.sharedModalService
          .openModal("error-modal", {
            title: "¡Error!",
            body: "Ha ocurrido un error al obtener los datos de la sesión",
          })
          .then(() => (this.openedModal = false));
      },
    });
  }

  handleDateClick(clickInfo: DateClickArg) {
    if (this.openedModal) {
      return;
    }
    this.openedModal = true;
    this.modalConfig.modalTitle = "Nueva Sesion";
    this.selectedClickDate = new Date(clickInfo.date);
    this.modalComponent.open().then(() => (this.openedModal = false));
  }
  async closeModal(close: boolean) {
    // Hardcoded For double Handling
    try {
      await this.modalComponent.close();
    } catch (error) {}
    try {
      await this.modalComponentEdit.close();
    } catch (error) {}
    this.selectedClickDate = null;
    this.selectedEvent = null;
    this.openedModal = false;
  }
}
